import * as io from 'io-ts';

export const ExperienceKeys = io.intersection([
  io.type({
    id: io.string,
    programID: io.string,
    merchantID: io.string,
    appID: io.string,
  }),
  io.partial({
    externalID: io.string,
    locationID: io.string,
    locationShortCode: io.union([io.string, io.null]),
  }),
]);

export type ExperienceKeys = io.TypeOf<typeof ExperienceKeys>;
